import React, { PropsWithChildren } from "react";
//#region types
import { FormControlProps } from "models/propTypes/formPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";

const ReadOnlyField: React.FC<PropsWithChildren<FormControlProps>> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { label, href, description } = props;

  const onClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    href &&
      navigate(href, {
        state: { background: location },
      });
  };

  return (
    <Grid container item direction="column" className={clsx(cssExports.readOnlyField, props.className)}>
      {label && (
        <Grid item className={clsx(cssExports.formControlLabel)}>
          {typeof label === "string" ? LocalizationHelperInstance.getFormattedMessage(label, label) : label}
        </Grid>
      )}
      <Grid
        item
        className={clsx(cssExports.fieldContent, href ? cssExports.readOnlyTextFieldLink : "")}
        onClick={href ? onClick : undefined}
      >
        {props.children}
      </Grid>

      {description && (
        <Grid item className={clsx(cssExports.formControlDescription)}>
          {LocalizationHelperInstance.getFormattedMessage(description, description)}
        </Grid>
      )}
    </Grid>
  );
};

export default ReadOnlyField;
